export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
}
